import React from 'react';
import classNames from 'classnames';
import { useMediaQuery } from '@mui/material';
import { getConfigObject } from '../../../../utils/config';
import s from './HeaderContainer.module.css';
import useSidePanel from '../../../SidePanel/hooks/useSidePanel';

function HeaderContainer({ children, hasPagination, innerRef }) {
  const {
    state: { mediaQueries },
  } = useSidePanel();

  const isSmall = useMediaQuery(`(max-width: ${mediaQueries.small}px)`);

  const { FF_SIDE_PANEL_ACTIVE = false } = getConfigObject();

  return (
    <div
      ref={innerRef}
      data-test-id="instructor_gradebook_header"
      className={classNames(s.layoutHeaderContainer, {
        [s.headerContainer]: FF_SIDE_PANEL_ACTIVE,
        [s.headerContainerSmall]: isSmall && hasPagination,
      })}
    >
      {children}
    </div>
  );
}

export default HeaderContainer;
